import AddUserSalesPage from "../../../component/users/sales/AddUserSalesPage";

 
function AddUserSales() {
  return (
    <div className="page-body">
      <AddUserSalesPage />
    </div>
  );
}

export default AddUserSales;
